import { Component, ElementRef, OnInit } from "@angular/core";
import { Pending } from "apps-module/app/shared-library/decorators/pending.decorator";
import { SearchStatus } from "apps-module/app/shared-library/enums/search-status.enum";
import { DestroyableMixin } from "apps-module/app/shared-library/mixins/destroyable.mixin";
import { LockMixin } from "apps-module/app/shared-library/mixins/lock.mixin";
import { ConfigurationService } from "apps-module/app/shared-library/services/configuration/configuration.service";
import { BrowserWindowService } from "apps-module/app/shared-library/services/environment/browser-window.service";
import { EmptyInstance } from "core-library/mixins/empty-instance";
import { filter, merge, of, Subscription, takeUntil, take } from "rxjs";

import { SearchForm } from "./forms/search.form";
import { FormSearchParametersModel } from "./models/form-search-parameters.model";
import { SearchConfigurationModel } from "./models/search-configuration.model";
import { SearchResultItemModel } from "./models/search-result-item.model";
import { SearchResultModel } from "./models/search-result.model";
import { FormSearchParametersService } from "./services/form-search-parameters.service";
import { QuerySearchParametersService } from "./services/query-search-parameters.service";
import { SearchService } from "./services/search.service";

@Component({
    selector: NewsSearchComponent.SELECTOR,
    templateUrl: "./news-search.component.html",
    providers: [ConfigurationService, FormSearchParametersService, SearchService, QuerySearchParametersService]
})
export class NewsSearchComponent extends DestroyableMixin(LockMixin(EmptyInstance)) implements OnInit {

    public static SELECTOR: string = "[pcg-ng-news-search]";

    // TODO: is this decorator necessary?
    @Pending
    private _onSearch: Subscription;

    public configuration: SearchConfigurationModel;
    public searchForm: SearchForm;
    public results: Array<SearchResultItemModel> = [];
    public totalPages: number = 1;
    public searchStatus: SearchStatus = SearchStatus.Loading;

    public constructor(
        private _domElement: ElementRef,
        private _browserWindowService: BrowserWindowService,
        private _configurationService: ConfigurationService<SearchConfigurationModel>,
        private _searchParametersFactory: FormSearchParametersService,
        private _searchService: SearchService,
        private _queryStringSetterService: QuerySearchParametersService
    ) { super(); }

    public ngOnInit(): void {
        this._configurationService.initialize(this._domElement);

        this.configuration = this._configurationService.config;

        const queryString = this._browserWindowService.getQueryString();
        const searchParameters = this._searchParametersFactory.create(queryString, this.configuration);
        this.searchForm = SearchForm.createForm(searchParameters);

        merge(of(searchParameters), this.searchForm.onFormSubmitted)
            .pipe(
                filter(() => !this.isLocked),
                takeUntil(this.onDestroy)
            )
            .subscribe(searchParams => this.invokeSearch(searchParams));
    }

    private invokeSearch(formSearchParameters: FormSearchParametersModel): void {
        this.searchStatus = SearchStatus.Loading;
        this._queryStringSetterService.set(formSearchParameters);

        this._onSearch = this._searchService.search(formSearchParameters)
            .pipe(take(1))
            .subscribe({
                next: (response: SearchResultModel) => {
                    const searchResult = {...response.results};

                    this.totalPages = searchResult.totalPages ?? 1;
                    this.results = [...searchResult.pageItems];
                    this.searchStatus = SearchStatus.Success;
                },
                error: () => this.searchStatus = SearchStatus.Error
            });
    }
}
